import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'registration',
    loadComponent: () =>
      import('./features/registration/registration.component').then(
        (c) => c.RegistrationComponent
      ),
  },
];
